import { IOrganizationGroupMinimal } from "@/api";
import { cn } from "@/lib/utils";

interface IProps {
    group: Pick<IOrganizationGroupMinimal, "id" | "name"> | null;
    prefix?: string;
    className?: string;
}

export const SharedWithGroupLabel = ({ group, prefix, className }: IProps) => {
    if (!group) {
        return null;
    }

    const label = `${prefix ? `${prefix}: ` : ""}Shared with ${group.name}`;

    return (
        <span
            className={cn(
                "text-muted-foreground block min-w-0 truncate text-xs",
                className
            )}
            title={label}
        >
            {label}
        </span>
    );
};
